<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: '',
    validator(value) {
      return ['in-person', 'virtual', 'on-demand']
        .includes(value.toLowerCase());
    },
  },
  width: String,
});

// this is the only way I was able to make these load reliably
const imagePath = computed(() => {
  if (props.type !== '') {
    const t = props.type?.toUpperCase();

    if (t === 'IN-PERSON') {
      return require('@/assets/img/Icon_In_Person_v1.svg');
    }
    if (t === 'IN-PERSON/VIRTUAL') {
      return require('@/assets/img/Icon_In Person_Virtual_Stacked_v1.svg');
    }
    if (t === 'VIRTUAL') {
      return require('@/assets/img/Icon_Virtual_v1.svg');
    }
    if (t === 'ON-DEMAND') {
      return require('@/assets/img/Icon_On_Demand_v1.svg');
    }
  }

  return false;
});
</script>

<template>
  <img
    v-if="imagePath"
    :width="width"
    :alt="`${type?.toLowerCase()} event-icon`"
    :src="imagePath"
  />
</template>
